export const CapitalizerProductID = -1;
export const RegulatorAIProductID = 1;
export const CAPAIProductID = 2;
export const SafetyAnalyticsProductID = 3;
export const ProjectAIProductID = 5;
export const AtomAssistProductID = 6;
